import { Link, useLocation } from "react-router-dom";
import { HugeiconsIcon } from "@hugeicons/react";
import { DashboardSquareAddIcon } from "@hugeicons-pro/core-solid-rounded";
import { BadgeVariant } from "shared/components";
import { useTrackUpsellEvent } from "api/boom-products/queries";
import gradientBg from "shared/app/BoomCrmPaywall/assets/gradient-bg.jpg";
import { NewBadge } from "shared/app/NewBadge";
import { cx } from "shared/utils";

const PRODUCTS_PATH = "/products";

/**
 * "Explore new products": pinned under the partner's own products. A 40px
 * tile with just the icon while the rail is collapsed; a small banner once it
 * opens (hover on desktop, or the mobile drawer).
 */
export const ExploreProductsNavButton = ({
  expanded
}: {
  expanded: boolean;
}) => {
  const { pathname } = useLocation();
  const track = useTrackUpsellEvent();
  const isActive = pathname === PRODUCTS_PATH;

  return (
    <div className="px-4 pb-3 pt-2">
      <Link
        to={PRODUCTS_PATH}
        aria-label="Explore new products"
        aria-current={isActive ? "page" : undefined}
        onClick={() =>
          track({
            product_key: null,
            event: "explore_nav_clicked",
            surface: "explore_nav"
          })
        }
        style={{ backgroundImage: `url(${gradientBg})` }}
        className={cx(
          "relative block w-full overflow-hidden rounded-lg bg-primary-500 bg-cover bg-right-top text-white no-underline shadow-[0_4px_11.3px_0_rgba(251,60,160,0.26)] transition-all hover:brightness-105",
          expanded ? "h-[92px]" : "h-10 md:group-hover:h-[92px]",
          isActive ? "ring-2 ring-primary-500 ring-offset-2" : ""
        )}
      >
        <span
          className={cx(
            "absolute left-[14px] top-[10px] transition-opacity",
            expanded ? "opacity-0" : "md:group-hover:opacity-0"
          )}
        >
          <HugeiconsIcon icon={DashboardSquareAddIcon} size={20} />
        </span>
        <span
          className={cx(
            "absolute inset-x-3 top-2.5 flex flex-col items-start whitespace-nowrap transition-opacity",
            expanded
              ? "opacity-100"
              : "opacity-0 md:group-hover:opacity-100 md:group-hover:delay-150"
          )}
        >
          <NewBadge variant={BadgeVariant.OUTLINE} className="mb-2" />
          <span className="text-sm font-bold text-white">
            Explore new products
          </span>
          <span className="text-xs text-white opacity-80">
            BoomReport, AI agents &amp; more
          </span>
        </span>
      </Link>
    </div>
  );
};
